module.exports = __webpack_public_path__ + "38c96152b5561cc537d2a24208d3ff06.png";